import React, { useEffect, useState } from 'react'
import Footer from '../footer/Footer'
import Navbar from '../Navbar';
import cal from '../../assets/images/cal.png';
import calculator from '../../assets/images/calculator.png';
import cal2 from '../../assets/images/3.png';
import cal3 from '../../assets/images/4.png';
import cal4 from '../../assets/images/5.png';
import cal5 from '../../assets/images/6.png';
import cal6 from '../../assets/images/7.png';
import cal8 from '../../assets/images/8.png';
import backbtn from '../../assets/images/backbtn.png'
import CalendarHook from './CalendarHook';
import { useLocation } from 'react-router-dom';
import { baseURLProd } from '../../api';

const CalendarDetail = () => {
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [confirmpopupOpen, setconfirmPopupOpen] = useState(false);
    const [attendanceMessage, setattendanceMessage] = useState('');

    // const location = useLocation();
    const classDetail = JSON.parse(sessionStorage.getItem('classDetail'));
    const user_id = JSON.parse(localStorage.getItem('userId'));

    const { handleBack, toggleModal, showModal, handleregisterClass, registrationMessage, showModal2,
        toggleModal2 } = CalendarHook()

    const handleLinkClick = async (event) => {
        console.log(classDetail,'class detail')
        // event.preventDefault();
        const formData = new FormData();
        formData.append("schedule_id", classDetail.schedule_id);
        formData.append("center", classDetail.center);
        formData.append("type", classDetail.type);
        formData.append("user_id", user_id);
        formData.append("is_mark", "1");
            console.log(formData,'forroro')
        try {
            const response = await fetch(`${baseURLProd}backup-attendance`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            if (data.status) {
                setPopupOpen(true);
                setattendanceMessage(data.message);
            } else {
                console.error('Error:', data.message);
            }
        } catch (error) {
            console.error('Error during API call:', error);
        }
    };

    const handlePopupOk = () => {
        setPopupOpen(false);
        handleLinkClick()
        window.open(classDetail.zoom_link, '_blank');
    };

    const handlePopupCancel = () => {
        setPopupOpen(false);
    };

    useEffect(() => {
        if (classDetail?.center === 'online') {
            setconfirmPopupOpen(true);
        }
    }, [])

    const handleconfirmPopupOk = () => {
        setconfirmPopupOpen(false);
    };

    const handleconfirmPopupCancel = () => {
        setconfirmPopupOpen(false);
    };
    return (
        <div>
            <Navbar />
            <div className='py-5 my-3'>
                <div className='mx-5 mt-5 mb-4'>
                    <img src={backbtn} onClick={handleBack} style={{ cursor: 'pointer' }} />
                </div>
                <div className="querycard">
                    {classDetail ? (
                        <>
                            <h4 className="text-center fw">{classDetail.class}</h4>
                            <div>
                                <div className="row mt-3">
                                    <div className="col">
                                        <div
                                            className="d-flex"
                                            style={{
                                                borderRadius: "20px",
                                                border: "1px solid #0055FF",
                                                padding: "6px",
                                            }}
                                        >
                                            <div className="me-4">
                                                <img src={cal} alt="Calendar" />
                                            </div>
                                            <div>
                                                <p className="fw mb-0">Date/ Day</p>
                                                <p className='mb-0'>{classDetail.date},{classDetail.day}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div
                                            className="d-flex"
                                            style={{
                                                borderRadius: "20px",
                                                border: "1px solid #A081F6",
                                                padding: "15px",
                                            }}
                                        >
                                            <div className="me-4">
                                                <img src={calculator} alt="Calculator" />
                                            </div>
                                            <div>
                                                <p className="fw mb-0">Center</p>
                                                <p className='mb-0'>{classDetail.center}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row my-5">
                                    <div className="col">
                                        <div
                                            className="d-flex"
                                            style={{
                                                borderRadius: "20px",
                                                border: "1px solid #2BBD18",
                                                padding: "15px",
                                            }}
                                        >
                                            <div className="me-4">
                                                <img src={cal2} alt="Start Time" />
                                            </div>
                                            <div>
                                                <p className="fw mb-0">Start Time</p>
                                                <p className='mb-0'>{classDetail.start_time}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div
                                            className="d-flex"
                                            style={{
                                                borderRadius: "20px",
                                                border: "1px solid #5AB8C3",
                                                padding: "15px",
                                            }}
                                        >
                                            <div className="me-4">
                                                <img src={cal3} alt="End Time" />
                                            </div>
                                            <div>
                                                <p className="fw mb-0">End Time</p>
                                                <p className='mb-0'>{classDetail.end_time}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* // <> */}
                                <div className='row'>
                                    <div className='col'>
                                        <div className='d-flex'
                                            style={{ borderRadius: "20px", border: "1px solid #E55577", padding: '15px' }}
                                        >
                                            <div className='me-4'>
                                                <img src={cal4}></img>
                                            </div>
                                            <div>
                                                <p className='fw mb-0'>Skill</p>
                                                <p className='mb-0'>{classDetail.skill}</p>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='col'>
                                        <div className='d-flex'
                                            style={{ borderRadius: "20px", border: "1px solid #F0B149", padding: '15px' }}
                                        >
                                            <div className='me-4'>
                                                <img src={cal5}></img>
                                            </div>
                                            <div>
                                                <p className='fw mb-0'>Topic</p>
                                                <p className='mb-0'>{classDetail.topics}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className='row my-5'>
                                    <div className='col-lg-6 col-md-6 col-sm-12'>
                                        <div className='d-flex'
                                            style={{ borderRadius: "20px", border: "1px solid #D146B2", padding: '15px' }}
                                        >
                                            <div className='me-4'>
                                                <img src={cal6}></img>
                                            </div>
                                            <div>
                                                <p className='fw mb-0'>Faculty</p>
                                                <p className='mb-0'>{classDetail.faculty}</p>
                                            </div>
                                        </div>

                                    </div>
                                    {classDetail.zoom_link ?
                                        <div className='col'>
                                            {classDetail.zoom_link ?
                                                <div className='d-flex'
                                                    style={{ borderRadius: "20px", border: "1px solid #A34ECA", padding: '15px' }}
                                                >
                                                    <div className='me-4'>
                                                        <img src={cal8}></img>
                                                    </div>
                                                    <div>
                                                        <p className='fw mb-0'>Zoom Link</p>
                                                        <p className='mb-0' style={{ cursor: "pointer" }} onClick={handleLinkClick}><a href={classDetail.zoom_link} ></a>{classDetail.zoom_link}</p>
                                                    </div>
                                                </div>
                                                : ""}
                                        </div>
                                        :
                                        <div className=''></div>
                                    }
                                </div>
                                {classDetail.type === 'registration' ?
                                    <div className='d-flex justify-content-center'>
                                        <button className='btn btn-success' style={{ background: "#ab3742", padding: "13px 46px", border: '0px' }}
                                            onClick={toggleModal}>Register</button>
                                    </div>
                                    : ""
                                }
                            </div>
                        </>
                    ) : (
                        <p>No class details available</p>
                    )}
                </div>

            </div>

            {showModal && (
                <div>
                    <div
                        className="modal-backdrop"
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            zIndex: 1040,
                        }}
                    ></div>
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                        {/* <div className="modal fade" style={{ display: 'block' }} tabIndex="-1" role="dialog"> */}
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header d-flex justify-content-end">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" onClick={toggleModal} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center ">
                                    Please Register for this class only if you are sure that you will attend it.<br />
                                    Registering and not attending may lead to us disallowing you from future Registration based classes.
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary loginBtn2" onClick={handleregisterClass}>
                                        Proceed
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showModal2 && (
                <div>
                    <div
                        className="modal-backdrop"
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            zIndex: 1040,
                        }}
                    ></div>
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header d-flex justify-content-end">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" onClick={toggleModal2} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center ">
                                    {registrationMessage}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary loginBtn2" onClick={toggleModal2}>
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isPopupOpen && (
                <div>
                    <div
                        className="modal-backdrop"
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            zIndex: 1040,
                        }}
                    ></div>
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header d-flex justify-content-end">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" onClick={handlePopupCancel} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center ">
                                    {attendanceMessage}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary loginBtn2" onClick={handlePopupOk}>
                                        Proceed
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
            {confirmpopupOpen && (
                <div>
                    <div
                        className="modal-backdrop"
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            zIndex: 1040,
                        }}
                    ></div>
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header d-flex justify-content-end">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" onClick={handleconfirmPopupCancel} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center ">
                                    Please join the online class with your name and your batch code
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary loginBtn2" onClick={handleconfirmPopupOk}>
                                        Ok
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
            <Footer />
        </div>
    )
}

export default CalendarDetail
